export const MAX_ADD_ONS_COUNT = 4;

export const ANCHOR_TOP_OFFSET = 90;
